import React from "react";

export default function Logo({ size = 36 }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 44 44"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="ITView logo"
        className="shrink-0"
      >
        <rect width="44" height="44" rx="10" fill="#1A1B1A" />
        <path
          d="M12 12 L12 24 L18 32 L18 20 Z"
          fill="#D05322"
        />
        <path
          d="M22 12 L28 28 L32 12 L28 12 L28 20 L26 12 Z"
          fill="#F4F3EF"
        />
        <circle cx="15" cy="15" r="1.4" fill="#F4F3EF" />
      </svg>
      <span className="font-display text-[19px] font-bold tracking-tight leading-none">
        ITView<span className="text-clay">.</span>
      </span>
    </div>
  );
}
